import React, { ReactNode } from "react"
import { Box, Stack, Text } from "@chakra-ui/react"
import Checkbox from "components/ReactHookForm/Checkbox"
import ContainedForm from "components/ReactHookForm/ContainedForm"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { DioboxEvent } from "sharedTypes"
import useCurrentPlanType from "utilities/useCurrentPlanType"

type Props = {
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const Option = ({ children, last = false }: { children: ReactNode, last?: boolean }) => (
  <Stack spacing={2} p={6} borderBottomWidth={last ? 0 : 1}>{children}</Stack>
)

const GuestActionsForm = ({ event, updateEvent }: Props) => {
  const { corporateFeaturesEnabled } = useCurrentPlanType()

  return (
    <ContainedForm values={event} onSubmit={updateEvent} name="Guest Actions" noPadding>
      {({ control }) => (
        <>
          <Option>
            <Checkbox
              name="guestsCanUpdateProfile"
              control={control}
              label={<Text fontWeight="semibold">Let guests edit their form submissions and profile</Text>}
              mb={0}
            />
            <Box ml={7}>
              <Text>
                Guests can update their registrations, tickets, or surveys after submitting.
                This also enables the Guest Profile page, where guests can keep their details
                up to date for future events.
              </Text>
            </Box>
          </Option>
          <Option>
            <Checkbox
              name="deferredTicketAssignmentEnabled"
              control={control}
              label={<Text fontWeight="semibold">Enable deferred guest registrations</Text>}
              mb={0}
            />
            <Box ml={7}>
              <Text>
                When two or more guests or tickets are registered at once, the buyer has the
                option to enter just their own name and email. They&apos;ll receive an email with
                links to complete each guest&apos;s details later. Until then, these guests appear
                as Unassigned Guests.
              </Text>
            </Box>
          </Option>
          <Option last>
            <Checkbox
              name="portalCaptchaEnabled"
              control={control}
              label={<Text fontWeight="semibold">Protect forms from bots with reCAPTCHA</Text>}
              mb={0}
              disabled={!corporateFeaturesEnabled}
            />
            <Stack ml={7} spacing={4}>
              <Text>
                Checks that free registrations and guest edits come from a real person. Strongly
                recommended, since unprotected forms can be flooded with fake submissions.
              </Text>
              <Text>
                If it causes issues with on-site registration, you can turn it off temporarily.
              </Text>
              {!corporateFeaturesEnabled && (
                <UpgradeAlert noBorder text="Turning this off requires Corporate Plan or higher." />
              )}
            </Stack>
          </Option>
        </>
      )}
    </ContainedForm>
  )
}

export default GuestActionsForm
